import React from 'react';
import { Settings } from '../../../config/api/models/Settings';

export const SettingsContext = React.createContext<{
  settings?: Settings;
}>({
  settings: undefined,
});
